import HeadTitle from '@/components/ui/custom/HeadTitle';
import PageTitle from '@/components/ui/custom/PageTitle';
import Layout from '@/components/template/Layout';
import { Fragment } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';
import NoAdminScreenForMobile from '../NoAdminScreenForMobile';
import PromptsPageContent from '@/components/prompts/PromptsPageContent';
import { ROUTES } from '@/utils/routes';

export default function ManagePrompts() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'prompts',
  });

  return (
    <Fragment>
      <HeadTitle routeInfo={t('pageTitle')} />

      <Layout>
        <div className="md:hidden">
          <NoAdminScreenForMobile />
        </div>
        <div className="hidden md:block w-full h-[calc(100%-80px)]">
          <PageTitle
            headingText={t('pageTitle')}
            backButton
            backButtonUrl={ROUTES.ADMIN.BASE}
            position="mb-3"
          />
          <PromptsPageContent />
        </div>
      </Layout>
    </Fragment>
  );
}
